import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { SurveyCarousel } from "../SurveyCarousel.js";
function SurveysPart({ part, allParts }) {
  var _a;
  const suppressOutput = allParts.some((p) => p.type === "data-survey-section");
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading surveys..." });
  if (suppressOutput) return null;
  const output = part.output;
  if (isOutputState(part.state) && ((_a = output == null ? void 0 : output.surveys) == null ? void 0 : _a.length) && output.surveys.length > 0) {
    return /* @__PURE__ */ jsx(SurveyCarousel, { surveys: output.surveys });
  }
  return null;
}
export {
  SurveysPart
};
//# sourceMappingURL=SurveysPart.js.map
